import { Component, OnInit, OnDestroy, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import { ActivatedRoute, Router } from '@angular/router';
import { Events } from '../../../utils/event-utils';
import { SocketService } from '../../../service/socket-service/socket-service.service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
declare var $;
@Component({
  selector: 'app-driver-alert',
  templateUrl: './driver-alert.component.html',
  styleUrls: ['./driver-alert.component.css']
})
export class DriverAlertComponent implements OnInit, OnDestroy {
  @ViewChild('messageTone', { static: true }) messageTone: ElementRef;
  isSound = true;
  driverList = [];
  driverSms = [];
  endPoint = null;
  searchDriver: any;
  searchMessages: any;
  newMessage = null;
  user;
  selectedDriver;
  driverId;

  constructor(
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.getUser();
    this.driverId = history.state.id
    this.endPoint = this.activatedRoute.snapshot.url[1].path;
    if (this.endPoint === 'driver-alerts') {
      this.getDriverList();
    } else if (this.endPoint === 'queries') {
      this.getQueriesUserList();
    }

    this.setUpDriverAlertSocketListener();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
        }
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
          if(this.driverId){
            const driverObj = this.driverList.find(d => d._id === this.driverId)
            this.fetchSms(driverObj)

          }else{
            this.fetchSms(this.driverList[0])
          }
        }
      });
  }

  getQueriesUserList() {
    this.driverService
      .getQueriesUserList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
          this.fetchSms(this.driverList[0])
        }
      });
  }

  fetchSms(userObj) {
    this.selectedDriver = userObj;
    this.driverSms = [];
    if (this.endPoint === 'queries') {

      if (userObj._id) {

        const data = {
          driverObj: userObj,
          endPoint: this.endPoint
        };
        this.getDriverSms(data);
      }
      return;
    } else if (this.endPoint === 'driver-alerts') {
      if (userObj._id) {
        // this.selectedUserId = userObj._id;
        const data = {
          id: userObj._id,
          endPoint: this.endPoint
        };
        this.getDriverSms(data);
      }
      return;
    }

  }

  getDriverSms(payload) {
    this.driverService
      .getDriversSms(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
            this.driverSms = data;
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  getImage(userObj) {

    if (this.endPoint === 'queries') {
      if (userObj.driver) {
        if (userObj.driver.profileImageURL) {
          return userObj.driver.profileImageURL;
        }
        return '#';
      }
      return '#';
    } else if (this.endPoint === 'driver-alerts') {
      if (userObj.profileImageURL) {
        return userObj.profileImageURL;
      }
      return '/assets/images/placeholders/driver-placeholder.png';
    }
  }

  getDisplayName(userObj) {

    if (this.endPoint === 'queries') {
      if (userObj.driver) {
        if (userObj.driver.displayName) {
          return userObj.driver.displayName;
        }
        return '#';
      }
      return 'N/A';
    } else if (this.endPoint === 'driver-alerts') {
      if (userObj.displayName) {
        return userObj.displayName;
      }
      return 'N/A';
    }
  }

  sendMessage(callBound?) {
    const message = {
      title: '',
      message: this.newMessage ? this.newMessage : callBound,
      receiver: this.selectedDriver
    };
    this.socketService.emit(Events.DRIVER_ALERT_CALL, message);
    this.newMessage = null;
  }

  call() {
    const callTo = {
      to: this.selectedDriver._id,
      status: 'join'
    };
    this.socketService.emit(Events.DRIVER_CALL, callTo);
    this.sendMessage('outbound')
  }

  setUpDriverAlertSocketListener() {
    this.socketService.addListener(Events.DRIVER_ALERT_CALL)
    .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          this.driverSms.push(data.driverAlert);
          this.onMessagePlay();
        }else {
          sweetAlert('Error', data.message, 'error', 'OK');

        }
      });

    this.socketService.addListener(Events.RECEIVE_DRIVER_ALERT_MESSAGE_CALL)
    .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          if (this.selectedDriver && data.driverAlert.sender && data.driverAlert.sender._id === this.selectedDriver._id) {
          this.driverSms.push(data.driverAlert);
        }
       } else {
          sweetAlert('Error', data.message, 'error', 'OK');

        }
      });

  }





  onMessagePlay() {
      this.messageTone.nativeElement.play();
  }

  ngOnDestroy(): void {
  }
}
